import { request } from '../index'

export function getBarcodes(params = {}) {
    return request({ "url": "barcodes/", method:"GET", params})
}

export function createBarcodes(provided_barcode, description, product) {
    return request({ "url": "barcodes/", method:"POST", data:{provided_barcode, description, product}})
}

export function getIMG(id) {
    return request({ "url": `barcodes/${id}/get-img/`})
}

export function deleteBarcode(id){
    return request({"url": `barcodes/${id}/`, method: "DELETE"})
}


// WEBPACK FOOTER //
// ./src/api/barcodes/index.js